import * as vp from 'vopay';

type AccountUserPermissionRows = {
  label: vp.AccountUserPermissionsLabel;
  id: vp.AccountUserPermissionsId;
  icon: vp.Icons | undefined;
};

const buildAccountUserPermissionRows = (): AccountUserPermissionRows[] => [
  {
    label: vp.AccountUserPermissionsLabel.ViewSubaccounts,
    id: vp.AccountUserPermissionsId.ViewSubaccounts,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.AddSubaccounts,
    id: vp.AccountUserPermissionsId.AddSubaccounts,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.CreatePayments,
    id: vp.AccountUserPermissionsId.CreatePayments,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.CreateCollections,
    id: vp.AccountUserPermissionsId.CreateCollections,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewBeneficiaries,
    id: vp.AccountUserPermissionsId.ViewBeneficiaries,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.AddBeneficiaries,
    id: vp.AccountUserPermissionsId.AddBeneficiaries,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewBulkFileUpload,
    id: vp.AccountUserPermissionsId.ViewBulkFileUpload,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.CreateBulkFileUpload,
    id: vp.AccountUserPermissionsId.CreateBulkFileUpload,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewScheduledTransactions,
    id: vp.AccountUserPermissionsId.ViewScheduledTransactions,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewTransactionHistory,
    id: vp.AccountUserPermissionsId.ViewTransactionHistory,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ApproveTransactions,
    id: vp.AccountUserPermissionsId.ApproveTransactions,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.TransactionCancellation,
    id: vp.AccountUserPermissionsId.TransactionCancellation,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewTransactionReport,
    id: vp.AccountUserPermissionsId.ViewTransactionReport,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.CreateTransactionReport,
    id: vp.AccountUserPermissionsId.CreateTransactionReport,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ManageTransactionGroups,
    id: vp.AccountUserPermissionsId.ManageTransactionGroups,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewSettings,
    id: vp.AccountUserPermissionsId.ViewSettings,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.AddSettings,
    id: vp.AccountUserPermissionsId.AddSettings,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewUsers,
    id: vp.AccountUserPermissionsId.ViewUsers,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.AddUsers,
    id: vp.AccountUserPermissionsId.AddUsers,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ManageUserPermissions,
    id: vp.AccountUserPermissionsId.ManageUserPermissions,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.CreateAccountTransfer,
    id: vp.AccountUserPermissionsId.CreateAccountTransfer,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewClientAccounts,
    id: vp.AccountUserPermissionsId.ViewClientAccounts,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.AddClientAccounts,
    id: vp.AccountUserPermissionsId.AddClientAccounts,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.CreateClientAccountTransfers,
    id: vp.AccountUserPermissionsId.CreateClientAccountTransfers,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.CreateConversions,
    id: vp.AccountUserPermissionsId.CreateConversions,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ManageDefaultPayments,
    id: vp.AccountUserPermissionsId.ManageDefaultPayments,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.CreateSupportTickets,
    id: vp.AccountUserPermissionsId.CreateSupportTickets,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewSupportTickets,
    id: vp.AccountUserPermissionsId.ViewSupportTickets,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewReconciliation,
    id: vp.AccountUserPermissionsId.ViewReconciliation,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ViewAccountingBills,
    id: vp.AccountUserPermissionsId.ViewAccountingBills,
    icon: undefined,
  },
  {
    label: vp.AccountUserPermissionsLabel.ProcessAccountingBills,
    id: vp.AccountUserPermissionsId.ProcessAccountingBills,
    icon: undefined,
  },
];

export default buildAccountUserPermissionRows;
